import { FallbackProps } from 'react-error-boundary'
import GenericErrorBoundary from '../GenericErrorBoundary'

const GenericErrorBoundaryFallback = ({ error }: FallbackProps) => {
  return <GenericErrorBoundary error={error as Error} />
}

export default GenericErrorBoundaryFallback
